import type { ValidationErrors } from '../types/Candidate';

export const validateForm = (formData: FormData, devices: string[]): ValidationErrors => {
  const errors: ValidationErrors = {};

  // Contact Information
  if (!formData.get('firstName')?.toString().trim()) {
    errors.firstName = 'First Name is required';
  }
  if (!formData.get('lastName')?.toString().trim()) {
    errors.lastName = 'Last Name is required';
  }
  
  const email = formData.get('email')?.toString().trim();
  if (!email) {
    errors.email = 'Email is required';
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errors.email = 'Invalid email format';
  }

  if (!formData.get('address')?.toString().trim()) {
    errors.address = 'Address is required';
  }
  if (!formData.get('city')?.toString().trim()) {
    errors.city = 'City is required';
  }
  if (!formData.get('state')?.toString().trim()) {
    errors.state = 'State is required';
  }
  
  const zip = formData.get('zip')?.toString().trim();
  if (!zip) {
    errors.zip = 'Zip Code is required';
  } else if (!/^\d{5}$/.test(zip)) {
    errors.zip = 'Zip Code must be 5 digits';
  }

  const cellPhone = formData.get('cellPhone')?.toString().trim();
  if (!cellPhone) {
    errors.cellPhone = 'Cell Phone is required';
  } else if (!/^\d{3}-\d{3}-\d{4}$/.test(cellPhone)) {
    errors.cellPhone = 'Cell Phone must be in format ###-###-####';
  }

  const homePhone = formData.get('homePhone')?.toString().trim();
  if (homePhone && !/^\d{3}-\d{3}-\d{4}$/.test(homePhone)) {
    errors.homePhone = 'Home Phone must be in format ###-###-####';
  }

  // Merchandising Experience
  if (!formData.get('hasDemonstratingExperience')?.toString().trim()) {
    errors.hasDemonstratingExperience = 'Please indicate if you have demonstrating experience';
  }
  if (!formData.get('canReadPlanogram')?.toString().trim()) {
    errors.canReadPlanogram = 'Please indicate if you can read a planogram';
  }
  if (!formData.get('otherFirms')?.toString().trim()) {
    errors.otherFirms = 'Please list other merchandising firms (or enter "None")';
  }
  if (!formData.get('currentCities')?.toString().trim()) {
    errors.currentCities = 'Please list cities where you do merchandising work';
  }
  if (!formData.get('currentMalls')?.toString().trim()) {
    errors.currentMalls = 'Please list malls where you do merchandising work';
  }
  if (!formData.get('pastOrCurrentStores')?.toString().trim()) {
    errors.pastOrCurrentStores = 'Please list stores where you work or have worked';
  }
  if (!formData.get('pastOrCurrentProducts')?.toString().trim()) {
    errors.pastOrCurrentProducts = 'Please list products you service or have serviced';
  }

  // Technology
  if (devices.length === 0) {
    errors.devices = 'Please select at least one device with internet connectivity';
  }
  if (!formData.get('hasPrinter')?.toString().trim()) {
    errors.hasPrinter = 'Please indicate if you have a printer';
  }
  if (!formData.get('hasAbilityToUploadPhotos')?.toString().trim()) {
    errors.hasAbilityToUploadPhotos = 'Please indicate if you can upload photos';
  }

  // Other
  if (!formData.get('hoursAvailablePerMonth')?.toString().trim()) {
    errors.hoursAvailablePerMonth = 'Please select hours available per month';
  }
  if (!formData.get('hasReliableTransportation')?.toString().trim()) {
    errors.hasReliableTransportation = 'Please indicate if you have reliable transportation';
  }
  if (!formData.get('howHeardAboutRac')?.toString().trim()) {
    errors.howHeardAboutRac = 'Please indicate how you heard about RAC';
  }

  return errors;
};
